module.exports = __webpack_public_path__ + "static/media/cyber-security-corn-hacker.941d2cb2.jpg";